import Radio from 'backbone.radio';

export default function() {
    var globalCh = Radio.channel('global');
    var selection;

    globalCh.reply('set_selection', function(new_selection) {
        selection = new_selection;
        globalCh.trigger('selection', selection);
    });

    globalCh.reply('selection', function() {
        return selection;
    });
}
